<template lang="pug">
  div
    b-input-group.input-group-sm
      template(v-slot:prepend)
        b-input-group-text {{ $t("ui." + text) }}
      template(v-if="text == 'username'")
        b-form-input(
          type="text"
          ref="target_id"
          :class="{ 'is-invalid': checkInvalid, 'is-valid': checkValid}"
          :placeholder="this.$t('ui.username')"
          v-model.trim.lazy="$v.target_id.$model"
          :maxLength="$v.target_id.$params.maxLength.max"
          :disabled="loading"
          @update="debounceCheck"
          size="sm"
        )
        ValidateResult(:value="$v.target_id" :name="$t('ui.target_id')")
          template(v-if="!isExisted" slot="msg")
            small.invalid.text-right {{ $t('ui.account_not_existed') }}
      template(v-else-if="text == 'action_by'")
        b-form-input(
          type="text"
          ref="action_by"
          :class="{ 'is-invalid': checkInvalid2, 'is-valid': checkValid2}"
          :placeholder="this.$t('ui.action_by')"
          v-model.trim.lazy="$v.action_by.$model"
          :maxLength="$v.action_by.$params.maxLength.max"
          :disabled="loading"
          @update="debounceCheck"
          size="sm"
        )
        ValidateResult(:value="$v.action_by" :name="$t('ui.action_by')")
          template(v-if="!isExisted" slot="msg")
            small.invalid.text-right {{ $t('ui.account_not_existed') }}
</template>

<script>
import config from "@/config";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import { required, maxLength, alphaNum } from "vuelidate/lib/validators";

export default {
  components: {
    ValidateResult,
    DebounceInput
  },
  props: {
    loading: Boolean,
    text: {
      type: String,
      default: "username"
    }
  },
  validations: {
    target_id: {
      exist(value, vm) {
        return vm.target_id === "" || vm.isExisted;
      },
      alphaNum,
      maxLength(value) {
        return maxLength(12)(value);
      }
    },
    action_by: {
      exist(value, vm) {
        return vm.action_by === "" || vm.isExisted;
      },
      alphaNum,
      maxLength(value) {
        return maxLength(12)(value);
      }
    }
  },
  data() {
    return {
      isExisted: false,
      debounceTimeout: null,
      target_id: "",
      action_by: "",
      checkTargetId: "",
      checkActionBy: ""
    };
  },
  computed: {
    checkValid() {
      return !this.$v.target_id.$error;
    },
    checkInvalid() {
      return this.$v.target_id.$error;
    },
    checkValid2() {
      return !this.$v.action_by.$error;
    },
    checkInvalid2() {
      return this.$v.action_by.$error;
    }
  },
  watch: {
    target_id(val) {
      this.checkTargetId = val !== "" ? val : this.$store.getters.accountID;
      this.$emit("updateValue", val);
    },
    action_by(val) {
      this.checkActionBy = val !== "" ? val : this.$store.getters.accountID;
      this.$emit("updateValue", val);
    }
  },
  methods: {
    checkDownline() {
      let id = (this.text == 'username') ? this.checkTargetId : this.checkActionBy;
      this.$store
        .dispatch("user/checkDownline", id)
        .then(res => {
          this.isExisted = res.success;
        });
    },
    debounceCheck(e) {
      if (e === "") return;
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(this.checkDownline, 500);
    }
  }
};
</script>